import { useEffect, useState } from "react";
import axios from "axios";
import Tooltip from "@mui/material/Tooltip";
import { FormGroup } from "reactstrap";
import Select from "react-select";
import "../../.csscode/PopUpModal.css";
import { toast } from "sonner";
import SucessModal from "../successModal/SuccessModal";
import CustomLoader from "../static/CustomLoader";

const WorkProcess = ({ selectedId, mode, onHide, setRefresh }) => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };
  const [id, setId] = useState("");
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [divcd, setDivCd] = useState("");
  const [completiontime, setCompletiontime] = useState("");
  const [divCdList, setDivCdList] = useState([{}]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [ShowSucessModal, setShowSucessModal] = useState(false);
  const [SucessMessage, setSucessMessage] = useState("");
  const [titile, setTitle] = useState("");

  const handleCloseSucessModal = () => {
    setShowSucessModal(false);
    setSucessMessage("");
    setTitle("");
    onHide();
    setRefresh(true);
  };

  useEffect(() => {
    fetchSelectedData();
    fetchDivision();
  }, []);

  const fetchSelectedData = async () => {
    setLoading(true);
    try {
      if (selectedId !== "") {
        const response = await axios.get(`${apiUrl}workprocess/${selectedId}`, {
          headers,
        });
        if (response.data.cd === 1) {
          toast.info(response.data.description);
        } else {
          setId(response.data.id);
          setCode(response.data.code);
          setName(response.data.name);
          setDivCd(response.data.divcd);
          setCompletiontime(response.data.completiontime);
        }
      }
    } catch (error) {
      toast.error("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  const fetchDivision = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}division`, { headers });
      if (response.data.cd === 1) {
        toast.info(response.data.description);
      }
      const sectionOption = response.data.map((op) => ({
        value: op.code,
        label: op.name,
      }));
      setDivCdList(sectionOption);
    } catch (error) {
      console.error("Error fetching division data:", error);
      setDivCdList([]);
    } finally {
      setLoading(false);
    }
  };

  function clearFields() {
    setName("");
    setDivCd("");
    setCompletiontime("");
  }

  const validateFields = () => {
    let errors = {};

    const isNumeric = (value) => !isNaN(value);

    if (!isNumeric(completiontime) || completiontime <= 0) {
      errors.completiontime =
        "Completion Time must be Required and it Should be Positive..!";
    } else if (completiontime.length > 6) {
      errors.completiontime = "Completion Time must not exceed 6 digits..!";
    }
    if (!name) errors.name = "Please Enter Name..!";
    if (divcd === "" || divcd === null)
      errors.divcd = "Please Select Department..!";

    return errors;
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const fieldErrors = validateFields();
    setErrors(fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
      toast.error("Please correct the errors in the form.");
      setLoading(false);
      return;
    } else {
      if (mode === "A") {
        const work = {
          code: code,
          name: name,
          divcd: divcd,
          completiontime: completiontime,
        };
        const response = await axios.post(apiUrl + "workprocess", work, {
          headers,
        });
        if (response.data.cd === 1) {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
        } else {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
        }
      } else {
        const work = {
          id: id,
          code: code,
          name: name,
          divcd: divcd,
          completiontime: completiontime,
        };
        const response = await axios.put(apiUrl + "workprocess", work, {
          headers,
        });
        if (response.data.cd === 1) {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("⚠️ Failed");
          setShowSucessModal(true);
        } else {
          setLoading(false);
          setSucessMessage(response.data.description);
          setTitle("✔️ Success");
          setShowSucessModal(true);
        }
      }
    }
  };

  const handleDivCdChange = (selectedOption) => {
    if (selectedOption) {
      const selectedDivCdValue = selectedOption.value;
      setDivCd(selectedDivCdValue);
    } else {
      setDivCd("");
    }
  };

  const customStyles = {
    placeholder: (provided) => ({
      ...provided,
      fontWeight: "normal",
      color: "#999",
    }),
    control: (provided) => ({
      ...provided,
      fontWeight: "normal",
      minHeight: "calc(1.5em + .75rem + 2px)",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  if (mode === "A") {
    /*Handle Save */
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="popupmodal-maindiv">
          <b>
            <div className="col-lg-12">
              <div className="form-group">
                <label>Name</label>
                <Tooltip title="Name">
                  <input
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="form-control mb-2"
                    placeholder="Enter Name"
                  ></input>
                </Tooltip>
              </div>
              {errors.name && (
                <span className="text-danger">{errors.name}</span>
              )}
            </div>
          </b>

          <FormGroup className="mb-3">
            <b>
              <label>Department</label>{" "}
            </b>
            <Select
              isClearable
              value={
                divcd
                  ? divCdList.find((option) => option.value === divcd)
                  : null
              }
              onChange={handleDivCdChange}
              placeholder="Select Department"
              styles={customStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              options={divCdList}
            />
            <b>
              {errors.divcd && (
                <span className="text-danger">{errors.divcd}</span>
              )}
            </b>
          </FormGroup>

          <b>
            <div className="col-lg-12">
              <div className="form-group">
                <label>Completion Time(in Minutes)</label>
                <Tooltip title="Completion Time">
                  <input
                    required
                    type="number"
                    value={completiontime}
                    onChange={(e) => setCompletiontime(e.target.value)}
                    className="form-control mb-2"
                    placeholder="Enter Time"
                  ></input>
                </Tooltip>
                {errors.completiontime && (
                  <span className="text-danger">{errors.completiontime}</span>
                )}
              </div>
            </div>
          </b>
          <div className="bottombtn">
            <button
              className="btn btn-success"
              onClick={handlesubmit}
              disabled={loading}
            >
              Save
            </button>
            {loading && <CustomLoader />}
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
        </div>
      </>
    );
  } else if (mode === "U") {
    return (
      <>
        <SucessModal
          show={ShowSucessModal}
          onClose={handleCloseSucessModal}
          headerText={titile}
          message={SucessMessage}
        />
        <div className="popupmodal-maindiv">
          <b>
            <div className="col-lg-12">
              <div className="form-group">
                <label>Code</label>
                <Tooltip title=" Work Process Code">
                  <input
                    required
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    className="form-control mb-2"
                    disabled="disabled"
                  ></input>
                </Tooltip>
                {code.length === 0 && (
                  <span className="text-danger">Enter the Code</span>
                )}
              </div>
            </div>
          </b>
          <b>
            <div className="col-lg-12">
              <div className="form-group">
                <label>Name</label>
                <Tooltip title="Name">
                  <input
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="form-control mb-2"
                    placeholder="Enter Name"
                  ></input>
                </Tooltip>
              </div>
              {errors.name && (
                <span className="text-danger">{errors.name}</span>
              )}
            </div>
          </b>

          <FormGroup className="mb-3">
            <b>
              <label>Department</label>{" "}
            </b>
            <Select
              isClearable
              value={
                divcd
                  ? divCdList.find((option) => option.value === divcd)
                  : null
              }
              onChange={handleDivCdChange}
              placeholder="Select Department"
              styles={customStyles}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              options={divCdList}
            />
            <b>
              {errors.divcd && (
                <span className="text-danger">{errors.divcd}</span>
              )}
            </b>
          </FormGroup>
          <b>
            <div className="col-lg-12">
              <div className="form-group">
                <label>Completion Time(in Minutes)</label>
                <Tooltip title="Completion Time">
                  <input
                    required
                    type="number"
                    value={completiontime}
                    onChange={(e) => setCompletiontime(e.target.value)}
                    className="form-control mb-2"
                    placeholder="Enter Time"
                  ></input>
                </Tooltip>
                {errors.completiontime && (
                  <span className="text-danger">{errors.completiontime}</span>
                )}
              </div>
            </div>
          </b>
          <div className="bottombtn">
            <button
              className="btn btn-success"
              onClick={handlesubmit}
              disabled={loading}
            >
              Update
            </button>
            {loading && <CustomLoader />}
            <button className="btn btn-danger" onClick={clearFields}>
              Reset
            </button>
          </div>
        </div>
      </>
    );
  }
};

export default WorkProcess;
